import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { AppModal, AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import { useDispatch } from "react-redux";
import { Formik } from 'formik';
import { ProgressBar } from 'react-bootstrap';
import _ from 'lodash';
import { axiosPath } from '../../../../../routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';
import SpinnerLoader from '../../../../components/helpers/SpinnerLoader';
import ErrorHandler from '../../../../components/error/ErrorHandler';

const UserModalExportPermissions = (props) => {
  const { showExportExcelModal, setShowExportExcelModal, userUsers, moduleBridgeHex } = props;
  const dispatch = useDispatch();

  const [batchLoop, setBatchLoop] = useState();
  const [usersSelectList, setUsersSelectList] = useState();
  const [modulesSelectList, setModulesSelectList] = useState();

  const handleLoadModalSelectUsers = useCallback(async () => {
    await axios
      .post(axiosPath("api_r_user_module_userManagement_user_list_select"), {
        moduleBridgeHex,
      })
      .then(({ data }) => {
        setUsersSelectList(data);
      })
      .catch((e) => dispatch(ErrorHandler(e, history)));
  }, [moduleBridgeHex]);

  const handleLoadModalSelectModules = useCallback(async () => {
    await axios
      .post(
        axiosPath("api_r_user_module_userManagement_user_modules_list_select"),
        {
          moduleBridgeHex,
          userName: userUsers[0].label,
        }
      )
      .then(({ data }) => {
        setModulesSelectList(data);
      })
      .catch((e) => dispatch(ErrorHandler(e, history)));
  }, [moduleBridgeHex, userUsers]);

  const exportPermissions = useCallback(async () => {
    await axios
      .post(
        axiosPath("api_r_user_module_userManagement_user_export_permissions"),
        {
          ...batchLoop,
        }
      )
      .then(({ data }) => {
        if (data?.isFinished) {
          setBatchLoop(null);
          window.open(data?.uri, "_blank");
        } else {
          setBatchLoop(data);
        }
      })
      .catch((e) => dispatch(errorHandler(e, history)));
  }, [batchLoop]);

  useEffect(() => {
    if (showExportExcelModal && userUsers) {
      if (!usersSelectList) handleLoadModalSelectUsers();
      if (!modulesSelectList) handleLoadModalSelectModules();
    }

    if (!showExportExcelModal) {
      setBatchLoop(null);
    }
  }, [showExportExcelModal]);

  useEffect(() => {
    if (batchLoop) {
      exportPermissions();
    }
  }, [batchLoop]);

  return (
    <AppModal
      show={showExportExcelModal}
      // title={ReactDOMServer.renderToString(
      //   <Translator file="admin" name="general.export-permissions-excel" />
      // )}
      title="Exportar permisos"
      size="xl"
      onClose={() => setShowExportExcelModal(false)}
    >
      <div>
        {
          !batchLoop
            ? (
              <Formik
                initialValues={{
                  tempBatchLoopID: null,
                  userName: userUsers ? userUsers[0].label : '',
                  moduleBridgeHex,
                  modulesHEX: [],
                  usersID: [],
                }}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={(v) => {
                  setBatchLoop({
                    ...v,
                    usersID: v.usersID.length > 0
                      ? v.usersID
                      : usersSelectList.map((ul) => ul.value),
                    modulesHEX: v.modulesHEX.length > 0
                      ? v.modulesHEX
                      : modulesSelectList.map((ml) => ml.value),
                  });
                }}
              >
                {({ setFieldValue, handleSubmit, values, isSubmitting }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-6">
                        <AppMultiSelect
                          options={usersSelectList}
                          title="Usuarios"
                          placeholder="Selecciona usuarios"
                          value={values.usersID}
                          icon={<AppRemixIcon icon="user" />}
                          isLoading={!usersSelectList}
                          hasSearchBox
                          onChange={(opt) => setFieldValue('usersID', opt)}
                          hasSelectOptions
                        />
                      </div>
                      <div className="col-6">
                        <AppMultiSelect
                          options={modulesSelectList}
                          title="Módulos"
                          placeholder="Selecciona un módulo"
                          value={values.modulesHEX}
                          icon={<AppRemixIcon icon="arrow-left-right" />}
                          isLoading={!modulesSelectList}
                          hasSearchBox
                          onChange={(opt) => setFieldValue('modulesHEX', opt)}
                          hasSelectOptions
                        />
                      </div>
                      <span className="col-12 pb-2">
                        Dejar vacío para seleccionar todos los elementos disponibles.
                      </span>
                    </div>
                    <div className="d-flex justify-content-end align-items-center mt-4">
                      {isSubmitting && (
                        <div className="mr-2">
                          <SpinnerLoader />
                        </div>
                      )}
                      <button
                        disabled={
                          isSubmitting ||
                          (!usersSelectList || (_.isArray(usersSelectList) && !usersSelectList.length) ||
                            !modulesSelectList) || (_.isArray(modulesSelectList) && !modulesSelectList.length)}
                        // disabled={isSubmitting || (!usersSelectList || !modulesSelectList)}
                        className={`btn btn-primary ${isSubmitting ? 'disable' : ''}`}
                        type="submit"
                        onClick={handleSubmit}
                      >
                        Generar
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            )
            : (
              <div className="pb-10">
                <h2>{batchLoop?.modalInfo?.message ?? 'Calculando información'}</h2>
                <ProgressBar
                  animated
                  now={batchLoop?.modalInfo?.percent ?? 0}
                  label={`${parseInt(batchLoop?.modalInfo?.percent ?? 0)}%`}
                />
              </div>
            )
        }

      </div>
    </AppModal>
  );
};

export default UserModalExportPermissions;
